export const currencyFormat = (amount, currency) => {
  // Default amount to 0 if it is null, NaN, or undefined
  const validAmount = isNaN(amount) || amount == null ? 0 : amount;

  if (currency) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
    }).format(validAmount);
  } else {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
    }).format(validAmount);
  }
};


export const customFormat = (amount) => {
  // Ensure the amount is a number and always has two decimal places
  const [whole, decimal] = amount.toFixed(2).split('.');

  // Add thousand separators using comma
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Combine whole and decimal parts with period as the decimal separator
  return `${formattedWhole}.${decimal}`;
};


// In utils/formatUtils.js
export const currencyFormatLKR = (
  amount,
  currency = "LKR",
  showCurrencyLabel = true
) => {
  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "LKR",
    currencyDisplay: "symbol",
  }).format(amount);
  return showCurrencyLabel
    ? `${formattedAmount}`
    : formattedAmount.replace(/LKR\s?/, "");
};

export default currencyFormat;
